'use client';

import React, { useState, useMemo } from 'react';
import EventsListHeader from './EventsListHeader';
import EventsGrid from './EventsGrid';
import { mockEvents, EventStatus } from './mockEvents';

export default function EventsListContent() {
  const [statusFilter, setStatusFilter] = useState<EventStatus | 'all'>('all');
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');
  const [sortBy, setSortBy] = useState<'date' | 'priority' | 'contacts'>('date');
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    let data = [...mockEvents];
    if (statusFilter !== 'all') data = data?.filter((e) => e?.status === statusFilter);
    if (search) {
      const q = search?.toLowerCase();
      data = data?.filter(
        (e) =>
          e?.name?.toLowerCase()?.includes(q) ||
          e?.city?.toLowerCase()?.includes(q) ||
          e?.country?.toLowerCase()?.includes(q) ||
          e?.type?.toLowerCase()?.includes(q)
      );
    }
    data?.sort((a, b) => {
      if (sortBy === 'date') return new Date(a.startDate)?.getTime() - new Date(b.startDate)?.getTime();
      if (sortBy === 'priority') {
        const po = { High: 0, Medium: 1, Low: 2 };
        return po?.[a?.priority] - po?.[b?.priority];
      }
      return b?.totalContacts - a?.totalContacts;
    });
    return data;
  }, [statusFilter, search, sortBy]);

  const counts = useMemo(() => ({
    all: mockEvents?.length,
    planned: mockEvents?.filter((e) => e?.status === 'planned')?.length,
    active: mockEvents?.filter((e) => e?.status === 'active')?.length,
    completed: mockEvents?.filter((e) => e?.status === 'completed')?.length,
    archived: mockEvents?.filter((e) => e?.status === 'archived')?.length,
  }), []);

  return (
    <div className="min-h-screen bg-background">
      <EventsListHeader
        statusFilter={statusFilter}
        onStatusFilter={setStatusFilter}
        viewMode={viewMode}
        onViewMode={setViewMode}
        sortBy={sortBy}
        onSortBy={setSortBy}
        search={search}
        onSearch={setSearch}
        counts={counts}
        total={filtered?.length}
      />
      <div className="px-6 xl:px-8 2xl:px-10 pb-10 max-w-screen-2xl mx-auto">
        <EventsGrid events={filtered} viewMode={viewMode} />
      </div>
    </div>
  );
}